<template>
  <v-dialog v-model="localStatus" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Edit assessment</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="assessmentState" @submit.prevent="save">
          <v-container fluid class="pt-0">
            <v-layout wrap align-top>
              <template v-for="(status, idx) in localFields">
                <v-flex :key="idx" xs3>
                  <h4 class="pt-2 pb-2">{{ status.title.replace(/\_/g, ' ') }}:</h4>
                </v-flex>
                <template v-for="(value, key) in status">
                  <template v-if="key !== 'title'">
                    <template v-if="isRating(value)">
                      <v-flex class="text-xs-right" :key="key" xs9>
                        <v-rating
                          v-model="status[key]"
                          background-color="green"
                          color="green"
                        />
                      </v-flex>
                    </template>
                    <template v-else>
                      <v-flex class="mb-2" :key="key" xs12>
                        <validate>
                          <v-textarea
                            v-model="status[key]"
                            :name="key"
                            :required="getRating(idx) < 5"
                            auto-grow
                            box
                            hide-details
                            color="success"
                          />
                          <field-messages
                            :name="key"
                            show="$dirty && $touched || $submitted"
                          >
                            <small class="error--text" slot="required">
                              {{ key.replace(/\_/g, ' ') }} is a required field
                            </small>
                          </field-messages>
                        </validate>
                      </v-flex>
                    </template>
                  </template>
                </template>
              </template>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-xl>
            <v-layout wrap align-top justify-end>
              <v-btn
                color="warning"
                flat
                @click="close"
                :disabled="isSending"
              >
                Close
              </v-btn>
              <v-btn
                type="submit"
                color="success"
                :disabled="isSending"
                :loading="isSending"
              >
                Save
              </v-btn>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Trial
  from '@/orm/models/Trial';

export default {
  name: 'assessmentPopup',
  props: {
    id: [String, Number],
    status: Boolean,
    fields: Array,
  },
  data() {
    return {
      assessmentState: {},
      localFields: [],
      isSending: false,
    };
  },
  watch: {
    fields: {
      immediate: true,
      handler() {
        this.setDefaultState();
      },
    },
  },
  computed: {
    localStatus: {
      get() {
        return this.status;
      },
      set(val) {
        this.$emit('update:status', val);
      },
    },
    formData() {
      const slug = this.currentGroup.slug.toLowerCase();
      const updateKey = `assessment_${ slug }`;
      const data = this.localFields.reduce((acc, obj) => {
        delete obj.title;
        return Object.assign(acc, obj);
      }, {});
      return {
        [updateKey]: {
          PRESENT: true, ...data,
        },
      };
    },
    getRating() {
      const fields = this.localFields;

      return (idx) => {
        return Object.entries(fields[idx]).reduce((acc, item) => {
          const [value] = item.reverse();
          if (this.isRating(value)) {
            acc += value;
          }
          return acc;
        }, 0);
      };
    },
  },
  methods: {
    isRating(val) {
      return typeof val === 'number';
    },
    setDefaultState() {
      this.localFields = JSON.parse(JSON.stringify(this.fields));
    },
    async save() {
      if (!this.assessmentState.$valid) return;
      try {

        this.isSending = true;
        const { status, id } = await Trial.find(+this.id);

        await Trial.$update({
          params: {
            id,
          },
          data: {...Object.assign({ status }, this.formData), user_role: this.currentGroup.slug}
        });

      } finally {
        this.isSending = false;
        this.localStatus = false;
      }
    },
    close() {
      this.localStatus = false;
      this.setDefaultState();
    },
  },
};
</script>
